<template>
    <div class="tw:pb-10 tw:w-full tw:px-2 tw:sm:px-4 tw:mx-auto">
        <breadcrumb-page :title="title" :items="listBreadcrumb" />

        <div v-if="$slots.header"
            class="tw:flex tw:flex-col tw:sm:flex-row tw:sm:flex-wrap tw:sm:items-center tw:sm:justify-end tw:gap-3 tw:sm:gap-4 tw:pb-4">
            <slot name="header"></slot>
        </div>

        <div
            :class="`tw:bg-white tw:rounded-2xl tw:sm:rounded-3xl tw:border tw:border-slate-200/80 tw:shadow-xl tw:shadow-slate-200/50 tw:transition-all ${classBody}`">
            <slot name="body"></slot>
        </div>

        <slot name="footer"></slot>
    </div>
</template>

<script>
export default {
    name: 'BasePage',
    props: {
        title: {
            type: String,
            default: ''
        },
        classBody: {
            type: String,
            default: ''
        },
        listBreadcrumb: {
            type: Array,
            default: () => []
        }
    }
}
</script>